import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import api from "../../services/api";
import { useWorkspace } from "../../utils/WorkspaceContext";
import useDebounce from "../../hooks/debounceHook";

const CreateEpicDialog = ({ open, onClose, onSuccess }) => {
  const { currentWorkspace } = useWorkspace();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    workspace: currentWorkspace?.id,
  });

  const debouncedCreateEpic = useDebounce(async (epicData) => {
    try {
      await api.post("epics/", epicData);
      onSuccess();
    } catch (error) {
      console.error("Error creating epic:", error);
    }
  }, 1000);

  const handleSubmit = (e) => {
    e.preventDefault();
    formData.workspace = currentWorkspace.id;
    debouncedCreateEpic(formData);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create New Epic</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Epic Name"
            fullWidth
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            multiline
            rows={4}
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="contained">
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateEpicDialog;
